import { type JSX } from "react";
import { BOARD_ICON_MAP, DEFAULT_BOARD_ICON_ID } from "./BoardIconMap";

const DEFAULT_ICON = BOARD_ICON_MAP[DEFAULT_BOARD_ICON_ID];

interface BoardIconProps {
  icon?: string;
  className?: string;
}

export function BoardIcon({ icon, className }: BoardIconProps): JSX.Element {
  const IconComponent = (icon ? BOARD_ICON_MAP[icon] : undefined) ?? DEFAULT_ICON;
  return <IconComponent className={className} />;
}
